import { addMinutes } from "date-fns/esm";
import { navigate } from "gatsby";
import store from "../store";
import { getCustomerDetails, getAuthenticationToken } from "./restFunctions";
import handleResponseFromAPI from "./handleResponseFromAPI";

const reduceTokenExpiration = () => {
  const minutes = 60;
  return addMinutes(new Date(), minutes);
};

const handleGetAuthenticationToken = (username, password, source) => {
  return getAuthenticationToken(username, password, source)
    .then(response => {
      return handleResponseFromAPI(response);
    })
    .catch(() => {
      return null;
    });
};

const handleGetCustomerDetails = (username, token, source) =>
  getCustomerDetails(username, token, source)
    .then(response => {
      return handleResponseFromAPI(response);
    })
    .catch(() => {
      return null;
    });

const finallyClear = () => {
  store.setUI("formSubmitting", false);
  store.setUI("gettingCustomerDetails", false);
};

const signInSubmit = async (values, source) => {
  const { username, password } = values;
  const {
    forms: { signInForm }
  } = store;
  store.setUI("formSubmitting", true);
  handleGetAuthenticationToken(username, password, source)
    .then(authenticationToken => {
      if (authenticationToken) {
        authenticationToken.expiry = reduceTokenExpiration();
        return authenticationToken;
      }
      return null;
    })
    .then(async authenticationToken => {
      if (authenticationToken) {
        const { token } = authenticationToken;
        store.setUI("gettingCustomerDetails", true);
        await handleGetCustomerDetails(username, token, source).then(
          customerDetails => {
            if (customerDetails) {
              if (!customerDetails?.username) {
                customerDetails.username = username;
              }
              store.setAuthenticationToken(authenticationToken);
              store.setCustomerDetails(customerDetails);
              if (signInForm) {
                signInForm.clear();
              }
              finallyClear();
              return navigate("/your-pawns");
            }
            return null;
          }
        );
      }
      return null;
    })
    .finally(() => {
      finallyClear();
    });
};

export default signInSubmit;
